/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteChatConversation200Response
 */
export interface DeleteChatConversation200Response {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteChatConversation200Response
     */
    success?: boolean;
}

/**
 * Check if a given object implements the DeleteChatConversation200Response interface.
 */
export function instanceOfDeleteChatConversation200Response(value: object): value is DeleteChatConversation200Response {
    return true;
}

export function DeleteChatConversation200ResponseFromJSON(json: any): DeleteChatConversation200Response {
    return DeleteChatConversation200ResponseFromJSONTyped(json, false);
}

export function DeleteChatConversation200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteChatConversation200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
    };
}

export function DeleteChatConversation200ResponseToJSON(json: any): DeleteChatConversation200Response {
    return DeleteChatConversation200ResponseToJSONTyped(json, false);
}

export function DeleteChatConversation200ResponseToJSONTyped(value?: DeleteChatConversation200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
    };
}

